<template>
  <div class="container">
    <div class="header">
      <img
        src="../../../static/qi_logo.png"
        alt=""
        @click="$router.push('/')"
        style="cursor: pointer"
      />
    </div>
    <div class="section">
      <div class="box">
        <div class="box_title">取回密码</div>
        <div class="input_box">
          <el-input
            type="tel"
            v-model="password"
            show-password
            placeholder="密码(必须同时包含字母和数字,长度&gt;8)"
          ></el-input>
        </div>
        <div class="input_box">
          <el-input
            type="tel"
            show-password
            v-model="newPassword"
            placeholder="新密码"
          ></el-input>
        </div>
        <el-button type="primary" @click="changePassword">确定修改</el-button>
      </div>
    </div>
    <div class="footer">
      <div style="margin-right: 10px">荷塘查策网</div>
      <div>湘ICP备2023013557号</div>
    </div>
  </div>
</template>

<script>
import { findPasswordAPI } from "@/api/index";
export default {
  data() {
    return {
      phone: "",
      code: "",
      password: "",
      newPassword: "",
    };
  },
  mounted() {
    this.phone = this.$route.query.phone;
    this.code = this.$route.query.code;
  },
  methods: {
    changePassword() {
      let validationStr = /^(?=.*[0-9])(?=.*[a-zA-Z])(.{8,})$/;
      if (!validationStr.test(this.password)) {
        this.password = "";
        this.$message.error("密码不符合要求");
        return;
      }
      if (this.password !== this.newPassword) {
        this.password = "";
        this.newPassword = "";
        this.$message.error("两次密码不一致");
        return;
      }
      let data = {
        password: this.password,
        phone: this.phone,
        code: this.code,
      };
      findPasswordAPI(data).then((res) => {
        this.$message.success(res.data.msg);
        setTimeout(() => {
          this.$router.push("/login");
        }, 300);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .header {
    width: 1200px;
    height: 120px;
    display: flex;
    align-items: center;
  }
  .section {
    width: 100%;
    flex: 1;
    background: #eee;
    padding-top: 100px;
    .box {
      width: 400px;
      margin: 0 auto;
      background: #fff;
      border-radius: 12px;
      padding: 0 30px 30px;
      .box_title {
        height: 50px;
        display: inline-block;
        line-height: 48px;
        border-bottom: 2px solid #409eff;
      }
      .input_box {
        margin-top: 10px;
        border-bottom: 1px solid #cccccc;
        display: flex;
        align-items: center;
        /deep/.el-input {
          flex: 1;
        }
        .code {
          white-space: nowrap;
          margin-left: 10px;
          cursor: pointer;
        }
        .code:hover {
          color: #409eff;
        }
      }
      /deep/.el-button--primary {
        width: 100%;
        height: 50px;
        margin-top: 20px;
      }
    }
  }
  .footer {
    text-align: center;
    padding: 40px;
    display: flex;
  }
}
/deep/ .el-input__inner {
  border: 1px solid transparent;
  flex: 1;
}
</style>
